import ContactInfo from 'layouts/Contact/ContactInfo';
import React from 'react';

export default function Contact() {
  return (
    <React.Fragment>
      <ContactInfo />
    </React.Fragment>
  );
}